import { DataObjectOutlinedIcon } from 'tuui';
import CommonCollapsibleCard from 'components/CommonCollapsibleCard/CommonCollapsibleCard';
import { SectionHeader } from 'modules/campaigns/components';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './subscriptionOutputSection.module.scss';

export const SubscriptionOutputSection = () => (
    <CommonCollapsibleCard
        id="SUBSCRIPTION_OUTPUT"
        header={
            <SectionHeader
                headerIcon={<DataObjectOutlinedIcon />}
                headerText={
                    <FormattedMessage
                        id="push-api.subscription.creator.output.step.title"
                        defaultMessage="Subscription Output"
                    />
                }
            />
        }
        containerClassName={styles['card-container']}
    >
        <div className={styles['col-list']}>
            <pre className={styles['json-output']}>
                <code>
                    {JSON.stringify(
                        {
                            metadata: {
                                performer: 'user@taboola.com',
                                change_time_in_utc: '2025-01-01 12:00:00',
                                numeric_account_id: 1234567890,
                            },
                            changed_entity_fields: {
                                credit_limit_model: 'CCB',
                                credit_limit: 100,
                                advertiser_type: 'None',
                            },
                            previous_entity_fields: {},
                            entity: {
                                id: 1234567890,
                                type: 'PARTNER',
                                name: 'Realize Account - user@taboola.com',
                                account_id: 'taboolaaccount-user',
                                admin_network: 'taboola-network',
                                parent_network: 'taboola-network',
                                groups: [],
                                parent_network_groups: [],
                                timezone: 'Europe/London',
                                language: 'EN',
                                partner_types: ['ADVERTISER'],
                                is_active: true,
                                campaign_types: ['PAID'],
                                native_integration_model: {},
                                domains: ['xyz.com'],
                                crm_id: 'Pending automatic update - do not edit',
                                country: 'US',
                                legal_entity: 'TABOOLA_US',
                                advertiser_type: 'None',
                                in_named_advertiser_list: false,
                                is_managed_by_agency: false,
                                tier: 'Low Touch',
                                salesforce_id: 'Pending automatic update - do not edit',
                                processing_fee: 0,
                                guarantee_rule: [],
                                predicted_tier: -99999,
                                advertiser_metadata: {
                                    is_frozen: false,
                                    credit_data: {
                                        credit_limit_model: 'CCB',
                                        credit_limit: 100,
                                    },
                                },
                                publisher_tier: -99999,
                                effective_rev_share: 0,
                                is_fla: false,
                                notifications_model: {},
                                media_account_manager_rep: '123456',
                                media_sales_rep: '123456',
                                current_media_sales_rep: '123456',
                                billing_status: 'PENDING',
                                default_platform: 'BACKSTAGE',
                                external_metadata: {
                                    data: [],
                                },
                                currency: 'EUR',
                                bidding_strategy_data: {
                                    cpc_cap_enabled: false,
                                },
                                pooled_guarantee: false,
                            },
                        },
                        null,
                        2
                    )}
                </code>
            </pre>
        </div>
    </CommonCollapsibleCard>
);
